export const USER_TYPES = {
  TEACHER: 'T',
  STUDENT: 'S',
  MANAGER: 'M',
  ADMIN: 'A',
  ANY: 'ANY',
};
